import React from 'react';
import AppButtonGroup from 'components/main/AppButtons';
import DiscordButton from 'components/main/DiscordButton';
import { Stack, Image } from 'tamagui';
import { Center, Flex } from 'components/base/General';
import { HeaderText } from 'components/utility/General';
import { wrapImgCDN } from 'utils/misc';
import { TouchableOpacity } from 'components/utility/Buttons';
import { useColorModeValue } from 'utils/hooks';
import { ChevronDownIcon } from 'app/components/utility/SVGIcons';
import { Hidden } from 'components/base/General';
export const ScrollDownButton = () => {
  const scrollDown = () => {
    document.querySelector('#filters').scrollIntoView({
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/React.createElement(Flex, {
    nativeID: "scrollDownButton",
    mt: 75,
    mb: 25,
    $md: {
      mt: -25,
      mb: 100
    },
    $lg: {
      mt: -25,
      mb: 100
    },
    $xl: {
      mt: -25,
      mb: 100
    },
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(HeaderText, {
    fontWeight: "bold",
    color: "white"
  }, "Or Read Below"), /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: scrollDown,
    style: {
      flexShrink: 1
    }
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    size: 68,
    color: '#FFF'
  })));
};
const SecondaryHeader = () => {
  return /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Stack, {
    justifySelf: "center",
    flexDirection: "column",
    width: "100%",
    $md: {
      justifySelf: 'space-between',
      flexDirection: 'row'
    },
    $xl: {
      width: '85%'
    },
    px: 5,
    mb: "-10rem",
    pt: "2rem",
    pb: 5
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    justifyContent: "center",
    mb: "6rem"
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(HeaderText, {
    fontSize: "$6xl",
    textAlign: "center",
    $md: {
      textAlign: 'left'
    },
    headerLevel: 1,
    color: "white"
  }, "Learn Chinese"), /*#__PURE__*/React.createElement(HeaderText, {
    fontSize: "$xl",
    textAlign: "center",
    $md: {
      textAlign: 'left'
    },
    opacity: 0.5,
    headerLevel: 2,
    color: "white"
  }, "Using hundreds of free articles")), /*#__PURE__*/React.createElement(Stack, {
    alignItems: "center",
    $md: {
      alignItems: 'stretch'
    }
  }, /*#__PURE__*/React.createElement(HeaderText, {
    color: "white",
    mt: 35,
    mb: 35,
    textAlign: "center",
    opacity: 0.5,
    headerLevel: 2,
    width: 400,
    maxWidth: "100%",
    $md: {
      width: 425,
      textAlign: 'left'
    },
    $lg: {
      width: 500,
      textAlign: 'left'
    }
  }, "There are also sentence translations, grammar rules, tone colors, a full 100,000 word dictionary, multiple quizzes, and more!")), /*#__PURE__*/React.createElement(Stack, {
    gap: 10,
    mb: 10
  }, /*#__PURE__*/React.createElement(AppButtonGroup, {
    flexDirection: "column",
    alignItems: "center",
    $md: {
      flexDirection: 'row',
      alignItems: 'flex-start'
    },
    justifyContent: 'flex-start'
  }), /*#__PURE__*/React.createElement(HeaderText, {
    color: "white",
    mt: 10,
    mb: 10,
    textAlign: "center",
    opacity: 0.5,
    headerLevel: 2,
    width: 400,
    maxWidth: "100%",
    alignSelf: "center",
    $md: {
      width: 425,
      textAlign: 'left',
      alignSelf: 'flex-start'
    },
    $lg: {
      width: 500,
      textAlign: 'left',
      alignSelf: 'flex-start'
    }
  }, "For support or improvement suggestions, join our Discord channel"), /*#__PURE__*/React.createElement(DiscordButton, null)))), /*#__PURE__*/React.createElement(Hidden, {
    from: "base",
    till: "md"
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    alignSelf: "center",
    $md: {
      alignSelf: 'flex-end'
    },
    alignItems: "flex-end",
    maxWidth: 300
  }, /*#__PURE__*/React.createElement(Image, {
    zIndex: 5,
    flex: 1,
    width: 402,
    height: 600,
    resizeMode: "contain",
    source: {
      uri: 'https://akmvcaugzq.cloudimg.io/https://cdn.pandaist.com/BlackiPhoneFrame.png?w=402'
    },
    alt: "Mobile phone running Pandaist"
  }), /*#__PURE__*/React.createElement(Image, {
    zIndex: 1,
    position: 'absolute',
    top: 10,
    left: -105,
    right: 0,
    bottom: 0,
    flex: 1,
    width: 405,
    height: 575,
    resizeMode: "contain",
    source: {
      uri: 'https://akmvcaugzq.cloudimg.io/https://cdn.pandaist.com/PhoneScreenshot.png?w=405'
    },
    alt: "Mobile phone running Pandaist"
  })))), /*#__PURE__*/React.createElement(ScrollDownButton, null));
};
export default SecondaryHeader;